var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35372 12.4879C3.72229 11.3416 2.4313 9.85062 1.70179 8.90912C1.4978 8.64923 1.38707 8.32952 1.38707 8.00044C1.38707 7.67136 1.4978 7.35165 1.70179 7.09175C3.02197 5.38637 6.18933 1.875 9.88724 1.875C11.5461 1.875 13.097 2.58113 14.4234 3.51475",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7707 6.15112C11.5251 5.90408 11.2326 5.7076 10.9099 5.573C10.5872 5.4384 10.2408 5.36836 9.89059 5.36691C9.54041 5.36545 9.19341 5.43262 8.8696 5.56454C8.54579 5.69646 8.25158 5.89051 8.00393 6.13551C7.75629 6.38051 7.56012 6.6716 7.42673 6.99199C7.29334 7.31239 7.22538 7.65575 7.22677 8.00226C7.22815 8.34878 7.29885 8.69159 7.4348 9.01093C7.57074 9.33028 7.76923 9.61982 8.01883 9.86287",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81329 15L16.9612 1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11876 13.866C8.69281 14.0351 9.28831 14.1223 9.88725 14.125C13.5852 14.125 16.7525 10.6136 18.0727 8.90825C18.2766 8.64812 18.3872 8.32821 18.3871 7.99898C18.3869 7.66974 18.276 7.34994 18.0718 7.09C17.6078 6.49105 17.1101 5.91848 16.581 5.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.476d06fe429173a68e1cf2cbf3f82bd4.svg";
export { ForwardRef as ReactComponent };